export const PRODUCT_OTHER_LOAN = {
    PRODUCT_TYPES : [
        {
            value: 'Legal Fees',
            label: 'Legal Fees'
        },
        {
            value: 'Fintos Financial Report',
            label: 'Fintos Financial Report'
        },
        {
            value: 'Fintos Financing',
            label: 'Fintos Financing'
        },
        {
            value: 'Finscoring Report',
            label: 'Finscoring Report'
        },
        {
            value: 'Financial Health Check',
            label: 'Financial Health Check'
        },
        {
            value: 'Property Booking Fees',
            label: 'Property Booking Fees'
        }, 
        {
            value: 'Credit Card',
            label: 'Credit Card'
        }, 
        {
            value: 'Invinity Credit Loan',
            label: 'Invinity Credit Loan'
        }, 
        {
            value: 'Other not in lists',
            label: 'Other not in lists'
        }, 
    ],
    PAYMENT_MODES: [
        {
            value: 'Credit Card - Merchant',
            label: 'Credit Card - Merchant'
        },
        {
            value: 'IBG Transfer',
            label: 'IBG Transfer'
        },
        {
            value: 'Instant Transfer',
            label: 'Instant Transfer'
        },
        {
            value: 'Cheques',
            label: 'Cheques'
        },
        {
            value: 'Cash Payment',
            label: 'Cash Payment'
        },
        {
            value: 'Payment Getaway',
            label: 'Payment Getaway'
        },
        {
            value: 'Autorize payment (ICSB)',
            label: 'Autorize payment (ICSB)'
        },
        {
            value: 'Standing Order',
            label: 'Standing Order'
        },
        {
            value: 'Invoice',
            label: 'Invoice'
        },
        {
            value: 'Payroll Deduction',
            label: 'Payroll Deduction'
        },
        {
            value: 'Not Applicable',
            label: 'Not Applicable'
        },
        {
            value: 'Standard Instruction',
            label: 'Standard Instruction'
        },
    ]
}
export const PRODUCT_MHLV = {
    LOAN_TYPE : [
        {
            value: 'Secure Loan',
            label: 'Secure Loan'
        },
        {
            value: 'Unsecure Loan',
            label: 'Unsecure Loan'
        }
    ],
}

export const SST_OPTIONS = [
    { text: '0%', value: '0.00' },
    { text: '6%', value: '6.00' },
    { text: '8%', value: '8.00' }
]

export const FIRT_MONTH_NAME = {
	1: 'J',
	2: 'F',
	3: 'M',
	4: 'A',
	5: 'M',
	6: 'J',
	7: 'J',
	8: 'A',
	9: 'S',
	10: 'O',
	11: 'N',
	12: 'D'
}